import { MIX_PANEL } from '@Constants/types';

const initialState = {
    mixpanelScorecard: {
        riskLevel: '',
        extractionCount: 0,
        extractionText: '',
        ruleId: 0,
        rulePosition: 0,
        suggestedClauseGroupsCount: 0,
        suggestedClauseInserted: '',
        initializeStepStartTime: new Date(),
        analyzingDocumentStartTime: new Date(),
        generatingScorecardStartTime: new Date(),
        completionTime: new Date(),
        loadExistingScorecard: false
    },
    mixpanelClauses: {
        clausesInGroupCount: 0,
        subgroupsInGroupCount: 0,
        clauseClickedId: '',
        totalNumberParentClauseGroups: 0,
        totalNumberClauseGroups: 0,
        totalNumberClauses: 0,
        maxDepth: 0,
        numberClauseGroupsAfterFilter: 0
    },
    mixpanelLabels: {
        displayId: '',
        labelPosition: 0,
        numberOfExtractions: 0,
        numberOfExtractionChars: 0, //extractions character count for all extractions in policy
        numberOfCharsInExtraction: 0, // individual extraction character count
        labelViewId: ''
    },
    mixpanelMarkup: {
        risksToShow: '',
        skipTrackChanges: false
    },
    mixpanelContracts: {
        fileType: '', // docx or other
        uploadedByMe: false
    }
};

export default function mixPanelReducer(state = initialState, action) {
    switch (action.type) {
        case MIX_PANEL.MIXPANEL_DATA_SCORECARD:
            return {
                ...state,
                mixpanelScorecard: { ...state.mixpanelScorecard, ...action.payload }
            };
        case MIX_PANEL.MIXPANEL_DATA_SCORECARD_STEP_TIME:
            if (action.payload === 'initialize') {
                return {
                    ...state,
                    mixpanelScorecard: {
                        ...state.mixpanelScorecard,
                        initializeStepStartTime: new Date(),
                        analyzingDocumentStartTime: null,
                        generatingScorecardStartTime: null,
                        completionTime: null
                    }
                };
            }
            if (action.payload === 'analyzing') {
                return {
                    ...state,
                    mixpanelScorecard: {
                        ...state.mixpanelScorecard,
                        analyzingDocumentStartTime: new Date(),
                        generatingScorecardStartTime: null,
                        completionTime: null
                    }
                };
            }
            if (action.payload === 'generating') {
                return {
                    ...state,
                    mixpanelScorecard: {
                        ...state.mixpanelScorecard,
                        generatingScorecardStartTime: new Date(),
                        completionTime: null
                    }
                };
            }
            if (action.payload === 'completion') {
                return {
                    ...state,
                    mixpanelScorecard: {
                        ...state.mixpanelScorecard,
                        completionTime: new Date()
                    }
                };
            }

            return state;
        case MIX_PANEL.MIXPANEL_DATA_CLAUSE_LIBRARY:
            return {
                ...state,
                mixpanelClauses: { ...state.mixpanelClauses, ...action.payload }
            };
        case MIX_PANEL.MIXPANEL_DATA_LABELS:
            return {
                ...state,
                mixpanelLabels: { ...state.mixpanelLabels, ...action.payload }
            };
        case MIX_PANEL.MIXPANEL_DATA_MARKUP:
            return {
                ...state,
                mixpanelMarkup: { ...state.mixpanelMarkup, ...action.payload }
            };
        case MIX_PANEL.MIXPANEL_DATA_CONTRACTS:
            return {
                ...state,
                mixpanelContracts: { ...state.mixpanelContracts, ...action.payload }
            };
        default:
            return state;
    }
}
